import { Link } from 'react-router-dom';

const QUICK_ENTRIES = [
  { label: '电影', icon: 'ri-film-line', to: '/category?category=电影' },
  { label: '电视剧', icon: 'ri-tv-2-line', to: '/category?category=电视剧' },
  { label: '悬疑题材', icon: 'ri-question-mark', to: '/category?genre=悬疑' },
  { label: '爱情题材', icon: 'ri-heart-3-line', to: '/category?genre=爱情' },
  { label: '欧美地区', icon: 'ri-earth-line', to: '/category?region=美国' },
  { label: '日韩地区', icon: 'ri-global-line', to: '/category?region=韩国' },
  { label: '2024年', icon: 'ri-calendar-line', to: '/category?year=2024' },
  { label: '全部作品', icon: 'ri-apps-2-line', to: '/category' },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto max-w-6xl px-4 md:px-6">
      <div className="rounded-xl border border-background-200 bg-background-100 p-5 md:p-6">
        <div className="mb-4 flex items-center gap-2">
          <span className="flex h-6 w-6 items-center justify-center text-primary-400">
            <i className="ri-filter-3-line text-lg"></i>
          </span>
          <h3 className="font-heading text-base font-semibold text-foreground-950">分类快捷入口</h3>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8">
          {QUICK_ENTRIES.map((entry) => (
            <Link
              key={entry.label}
              to={entry.to}
              className="flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-2 py-4 text-center transition-colors hover:border-primary-500 hover:bg-background-200"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500/15 text-primary-300">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <span className="text-xs font-medium text-foreground-800">{entry.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}